import { SubComponentModel } from '@secca/case/components/case-plans/case-plans/add-service-order/models/interfaces';

export class SubRemarksFromSupplier implements SubComponentModel {
  remarks: string;
  id: number;

  public constructor(init?: Partial<SubRemarksFromSupplier>) {
    Object.assign(this, init);
  }

  isValid(): boolean {
    return true;
  }

}
